<template>
  <van-popup v-model="openModal" @click-overlay="maskClicked">
    <div class="wrapper">
      <div class="header"><span>{{knowledge.name}}</span><i class="icon icon-close" @click.stop="iconClicked"></i></div>
      <div class="content" v-if="Object.keys(knowledge).length">
        <div class="item" v-if="knowledge.survey">
          <div>{{typeCodeName[knowledge.mIndex][0]}}</div>
          <pre v-html="knowledge.survey"></pre>
        </div>
        <div class="item" v-if="knowledge.cause">
          <div>{{typeCodeName[knowledge.mIndex][1]}}</div>
          <pre v-html="knowledge.cause"></pre>
        </div>
        <div class="item" v-if="knowledge.suggestion">
          <div>{{typeCodeName[knowledge.mIndex][2]}}</div>
          <pre v-html="knowledge.suggestion"></pre>
        </div>
        <div class="item" v-if="!knowledge.suggestion&&!knowledge.cause&&!knowledge.survey">
          <p>无健康科普知识</p>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant'
import Vue from 'vue'

Vue.use(Popup)
export default {
  data () {
    return {
      typeCodeName: [
        ['疾病概述', '可能病因', '健康指导'],
        ['症状概述', '可能诱发', '健康建议'],
        ['基本介绍', '可能引发', '健康建议']
      ]
    }
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    knowledge: {
      type: Object,
      default: {}
    }
  },
  computed: {
    openModal: {
      get: function () {
        return this.showModal
      },
      set: function (v) {
        return !this.showModal
      }
    }
  },
  watch: {
    'knowledge' (newVal, oldVal) {
      document.getElementsByClassName('content')[0]
    }
  },
  methods: {
    maskClicked (e) {
      this.$emit('maskClicked', e)
    },
    iconClicked () {
      this.$emit('iconClicked')
    }
  },
  name: 'showKnowledge'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
@import "@/assets/style/variables.scss";

.van-popup {
  border-radius: 10px;
}

.wrapper {
  width: 320px;
}
.content{
  padding: 0 20px;
  margin-bottom: 20px;
  overflow-y:auto ;
  background: #ffffff;
  max-height: 400px;
}
.header {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 30px;
  position: relative;
  span {
    font-weight: bold;
    font-size: 18px;
    &:before {
      content: ' ';
      display: block;
      position: absolute;
      bottom: 24px;
      width: 30px;
      border-bottom: 2px solid $dark;
    }
  }
  .icon {
    font-size: 26px;
  }
}

.item {
  padding-bottom: 18px;
  div {
    font-size: 14px;
    font-weight: bold;
    padding-bottom: 6px;
  }

  p {
    font-size: 14px;
  }
}

</style>
